export enum ReportCategories {
    consultReport = 'consultReport',
    discharge = 'discharge',
    examinationReport = 'examinationReport',
    intake = 'intake',
}
